/* DM PREMIUM — los CTA abren el formulario de contraentrega (Releasit).

   OJO (bug real encontrado el 2026-08-13): Releasit inyecta VARIOS botones con
   el MISMO id #rsi_buy_now_button — en móvil son tres y solo uno tiene tamaño.
   querySelector devuelve el primero, que en móvil está vacío y no abre nada.
   Por eso hay que recorrerlos todos y quedarse con el que ocupa espacio. */
(function () {
  function conTamano(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.height > 10;
  }
  function botonCOD() {
    var todos = [].slice.call(document.querySelectorAll('[id="rsi_buy_now_button"]'));
    for (var i = 0; i < todos.length; i++) if (conTamano(todos[i])) return todos[i];
    return todos[0] || null;          // ninguno desplegado: intentar con el primero
  }
  function bloqueCompra() {
    var c = [document.querySelector('.product-form__submit'),
             document.querySelector('.product-form'),
             document.querySelector('[id^="ProductInfo-"]'),
             document.querySelector('.product__info-container')];
    for (var i = 0; i < c.length; i++) {
      if (c[i] && c[i].getBoundingClientRect().height > 10) return c[i];
    }
    return null;
  }
  function abrirFormulario(e) {
    var cod = botonCOD();
    if (cod) { e.preventDefault(); cod.click(); return; }
    var d = bloqueCompra();
    if (!d) return;
    e.preventDefault();
    var y = Math.max(0, d.getBoundingClientRect().top + window.pageYOffset - 90);
    var desde = window.pageYOffset;
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (err) { window.scrollTo(0, y); }
    setTimeout(function () {
      if (Math.abs(window.pageYOffset - desde) < 20) window.scrollTo(0, y);
      var b = botonCOD();
      if (b) b.click();
    }, 500);
  }
  function enganchar() {
    document.querySelectorAll('a[href="#main"], a[href="#"], [data-buy-cta]').forEach(function (el) {
      if (el.dataset.dmHooked) return;
      if (el.id === 'rsi_buy_now_button') return;
      if (el.closest('[class*="jdgm"], [id*="judgeme"]')) return;
      el.dataset.dmHooked = '1';
      el.addEventListener('click', abrirFormulario);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enganchar);
  else enganchar();
  setTimeout(enganchar, 1500);
})();
